import React from "react";
import "./Payment_Success_Modal.css";
import Successfull_Lottie from "../../Animation/Successfull_Lottie/Successfull_Lottie";

function Payment_Success_Modal({ successText, ...props }) {
  return (
    <>
      <section className="Success_modal Payment_Success_Modal">
        <div> <Successfull_Lottie successText="Order Placed Successfully" /></div>
       
        <div className="text-center mt-3">
          <h4>Your order has been placed successfully!</h4>
          <p>
            Thank you for your purchase. We've received your order and will
            process it shortly.
          </p>
        </div>
      </section>
    </>
  );
}

export default Payment_Success_Modal;
